const endpoints = {
  entities: (id = '') => `entities/${id}`,
  settings: () => `investor_accounts`,
  settingsUpdate: (id = '') => `investor_accounts/${id}`,
  investorAccounts: (id = '') => `investor_accounts/${id}`,
  users: (id = '') => `users/${id}`,
  contactAddresses: (id = '') => `contact_addresses/${id}`,
}

export default endpoints
